/* eslint-disable react-hooks/exhaustive-deps */
import { CameraOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Result, Space, Typography, Upload, message } from 'antd';
import EXIF from 'exif-js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Compress from 'react-image-file-resizer';
import BoxImage from '../../../../components/BoxImage';

import { useSiniestroContext } from '../../../../context/siniestro-context';
import { errorHandler, heicAndheifConvert, isMobile } from '../../../../utils';

export default function Tarjeta(props) {
  const { card, imagenes, siniestro, imagenAdicional, enabled } = props;

  const [imagen, setImagen] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [loadingImages, setLoadingImages] = useState(false);
  const [resultado, setResultado] = useState(false);
  const [xlatitud, setLatitud] = useState(0.0);
  const [ylongitud, setLongitud] = useState(0.0);

  const {
    uploadFile,
    setHasImagenesFunction,
    getImages,
    loading,
    setLoading,
    eliminarAdicional
  } = useSiniestroContext();

  const loadImage = async () => {
    Object.keys(imagenes).forEach(function test(key) {
      if (imagenes[key]?.paso_nro === card.key) {
        setDisabled(false);
        setImagen(imagenes[key].url);
        setHasImagenesFunction(true);
      }
    });
  };

  const saveimage = async (file, type) => {
    try {
      if (isMobile) {
        if (type) {
          setLoading(true);
          setLoadingImages(true);
          await uploadFile(file, card.key + 1, {
            ...siniestro,
            latitud: xlatitud,
            longitud: ylongitud
          });
          const reader = new FileReader();
          reader.onloadend = () => {
            props.setImagenAdicional(reader.result);
            getImages(siniestro);
            props.addStep();
          };
          setLoading(false);
          setLoadingImages(false);
          reader.readAsDataURL(file);
        } else {
          setLoading(true);
          setLoadingImages(true);
          await uploadFile(file, card.key, {
            ...siniestro,
            latitud: xlatitud,
            longitud: ylongitud
          });
          const reader = new FileReader();
          reader.onloadend = () => {
            setImagen(reader.result);
            getImages(siniestro);
            setDisabled(false);
            /* try {
              if (card.key === props.countPasos) {
                props.reload();
              }
            } catch (error) {
              // error
            } */
          };
          setLoading(false);
          setLoadingImages(false);
          reader.readAsDataURL(file);
        }
      } else {
        errorHandler(null, 'Debe tomar la foto desde un dispositivo móvil');
      }
    } catch (err) {
      setLoading(false);
      setLoadingImages(false);
      // error
    }
  };

  const getPosition = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(function test(position) {
        setLatitud(position.coords.latitude);
        setLongitud(position.coords.longitude);
      });
    }
  };

  const customRequest = async ({ file }, type) => {
    const converted = await heicAndheifConvert(file);
    try {
      Compress.imageFileResizer(
        converted, // the file from input
        2400, // width
        1600, // height
        'JPEG', // compress format WEBP, JPEG, PNG
        90, // quality
        0, // rotation
        (uri) => {
          saveimage(uri, type);
        },
        'blob' // blob or base64 default base64
      );
    } catch (error) {
      message.error(error);
    }
  };

  const beforeUpload = (file) => {
    // Extraer metadatos para validaciones
    if (file && file.name) {
      EXIF.getData(file, function getFileData() {
        const exifData = EXIF.getAllTags(this);
        if (Object.keys(exifData).length) {
          const fechaFoto = moment(exifData.dateTime).format();
          const fechaSiniestro = moment(siniestro.fecha_siniestro).format();
          if (fechaFoto < fechaSiniestro) {
            message.warning(
              'Fecha de fotografía es anterior a la fecha del siniestro'
            );
            return false;
          }
          // pass
        } else {
          return true;
        }
        return true;
      });
    }
    return true;
  };

  const eliminar = () => {
    setLoadingImages(true);
    eliminarAdicional(siniestro, card.key);
    props.eliminarPaso(card.key);
    setLoadingImages(false);
  };

  const getMessage = () => {
    if (disabled && !imagenAdicional) {
      return (
        <Typography.Paragraph style={{ paddingTop: 32 }}>
          Click en el ícono para tomar la fotografía
        </Typography.Paragraph>
      );
    }
    return null;
  };

  const ButtonImage = () => {
    return (
      <Upload
        style={{ width: 'auto !important' }}
        accept="image/jpeg,image/heif,image/heic"
        showUploadList={false}
        customRequest={(e) => customRequest(e, 'extra')}
        beforeUpload={beforeUpload}
        capture="environment"
      >
        <div>
          <Card
            cover={
              <Button type="dashed" shape="round">
                <CameraOutlined /> Agregar Fotografía adicional
              </Button>
            }
            bodyStyle={{ padding: '0' }}
            style={{
              border: 0,
              marginBottom: 20
            }}
          />

          <div className="background-hover" />
        </div>
      </Upload>
    );
  };

  const getButton = () => {
    return (
      <>
        {props.moreImages && (imagen || imagenAdicional) && (
          <div style={{ display: 'block' }}>
            <ButtonImage />
          </div>
        )}
        {props.delete && (
          <Button
            type="text"
            icon={<DeleteOutlined />}
            size="middle"
            onClick={() => eliminar()}
          />
        )}
        <Space>
          {props.back && <Button onClick={props.back}>Anterior</Button>}
          <Button
            onClick={() => {
              setResultado(true);
            }}
          >
            Guardar flujo
          </Button>
          <Button
            type="primary"
            disabled={disabled && !enabled}
            onClick={props.next}
          >
            Siguiente
          </Button>
        </Space>
      </>
    );
  };

  useEffect(() => {
    loadImage();
    getPosition();
    /* return function cleanup() {
      navigator.geolocation.clearWatch(whatchid);
    }; */
  }, []);

  return (
    <>
      {!resultado && (
        <>
          <BoxImage
            customRequest={customRequest}
            beforeUpload={beforeUpload}
            imagen={imagen || imagenAdicional || card.image}
            loading={loading || loadingImages}
            card={card}
          />
          {getMessage()}
          {getButton()}
        </>
      )}
      {resultado && (
        <Result
          status="success"
          title="¡Proceso guardado con éxito!"
          subTitle={
            <>
              <p>Estimado/a Sr/Sra {siniestro.poliza.persona.nombres}</p>
              <p>
                Su inspección ha sido guardada exitosamente, para continuar
                puede dar click al mismo link recibido inicialmente.{' '}
                <a
                  href={`${window.location.origin}/siniestros/form/${siniestro.token}`}
                >
                  Continuar inspección{' '}
                </a>{' '}
              </p>
              <strong>¡Muchas gracias!</strong>
            </>
          }
          extra={
            <Button
              type="primary"
              key="console"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Ir al inicio
            </Button>
          }
        />
      )}
    </>
  );
}
